exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js?modules&importLoaders=1!../../node_modules/postcss-loader/index.js!../style/space.css"), undefined);
exports.i(require("-!../../node_modules/css-loader/index.js?modules&importLoaders=1!../../node_modules/postcss-loader/index.js!../style/typography.css"), undefined);

// module
exports.push([module.id, "._3a07EE876f7MN8M6du-nMI,\n._28zE-S4svoBdMUlEYxW21o {\n  font-weight: 500;\n  font-family: \"sofia-pro\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  box-sizing: border-box;\n}\n\n._3a07EE876f7MN8M6du-nMI {\n\n  width: 100%;\n  padding: calc(" + require("-!../../node_modules/css-loader/index.js?modules&importLoaders=1!../../node_modules/postcss-loader/index.js!../style/space.css").locals["vru"] + " * 2);\n}\n\n._28zE-S4svoBdMUlEYxW21o {\n  text-align: center;\n}\n", ""]);

// exports
exports.locals = {
	"vru": "" + require("-!../../node_modules/css-loader/index.js?modules&importLoaders=1!../../node_modules/postcss-loader/index.js!../style/space.css").locals["vru"] + "",
	"container": "_3a07EE876f7MN8M6du-nMI " + require("-!../../node_modules/css-loader/index.js?modules&importLoaders=1!../../node_modules/postcss-loader/index.js!../style/typography.css").locals["base"] + "",
	"center": "_28zE-S4svoBdMUlEYxW21o"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=1!./~/postcss-loader!./src/Loading/loading.css
 ** module id = 467
 ** module chunks = 0
 **/